export const UPDATE_USER = 'Dyzio/UserWidget/UPDATE_USER';
export const CLEAR_USER = 'Dyzio/UserWidget/UPDATE_USER';



/** WEBPACK FOOTER **
 ** ./src/containers/user-widget/constants.js
 **/